import {isEmpty, cloneDeep, find} from 'lodash'
import {checkStripeAccountStatus} from '@/libs/api/api'
import {mapGetters} from 'vuex'
import {loader} from '@/libs/helper';
export default {
    name: 'DonationDetail',
    created () {
        this.getAccountStatus()
    },
    mounted() {
        this.$nextTick(() => {
            this.setSelectedValue(this.$route.params.id)
        })
    },
    props: {
        donations: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
            userInformation: 'getUserInformation'
        })
    },
    watch: {
        userInformation () {
            this.setSelectedValue(this.$route.params.id)
        }
    },
    data() {
        return {
            isEmpty,
            showDropdown: false,
            manageList: {},
            selectedValue: {},
            accountStatus: {}
        }
    },
    methods: {
        async getAccountStatus () {
            loader(this, true)
            try {
                // body for api
                let body = {
                    entity_id: this.$route.params.id,
                    entity_type: this.$route.params.type.toUpperCase()
                }
                // api call
                let response = await checkStripeAccountStatus(body)
                this.accountStatus = response
                loader(this, false)
            } catch (error) {
                console.error(error)
                loader(this, false)
            }
        },
        /**
         * routeTo
         * @param {*} type 
         * @param {*} id 
         */
        async routeToSettingsPage (type, data) {
            // to set the selecteValue
            this.selectedValue = data
            // to get the name of current route
            let name = this.$route.name
            await this.$router.push({name, params: {id: (data.id || data._id), type: type.toLowerCase()}}).catch(() => {})
            this.getAccountStatus()
        },
        
        /**
         * set the selectedValue for dropdown
         */
        setSelectedValue (id) {
            let selectedValue = {}
            if (id === this.userInformation.id) {
                selectedValue = cloneDeep(this.userInformation)
            } else {
                selectedValue = find(this.donations.organisations, {_id: id})
            }
            this.selectedValue = !isEmpty(selectedValue) ? selectedValue : {}
        }
    }
}